import { useEffect } from "react"
import { useAuth } from "~/store/auth-context"
import { useNavigate } from "react-router-dom"
import { Loader } from "@tfg/ui"

export const BlockedOnboardingRedirect = () => {
  const { logout } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    let active = true
    logout().finally(() => {
      if (active) navigate("/login", { replace: true })
    })
    return () => {
      active = false
    }
  }, [logout, navigate])

  return <Loader fullPage />
}
